<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "home-container",
}
</script>

<style scoped>
  .container {
    padding: 10px;
    flex: 1 1 auto;
    overflow: hidden;
  }
</style>
